import { PhotoData } from "./user.data";
import { Asset } from './assets.data';


export type TFilterUI = 'SubCheckbox' | 'Checkbox' | 'PhotoLabel' | 'NestedLabelGroup' | 'ColoredLabel' | 'Icon' | 'Asset'| 'AssetType'
export const FilterUIType: { [FUI in TFilterUI]: FUI }  = {
		SubCheckbox: 'SubCheckbox',
    Checkbox: 'Checkbox',
    PhotoLabel: 'PhotoLabel',
    NestedLabelGroup: 'NestedLabelGroup',
    ColoredLabel: 'ColoredLabel',
    Icon: 'Icon',
    Asset: 'Asset',
    AssetType: 'AssetType'
}

export interface FilterUI {
    type: TFilterUI
    name: string
    selected: boolean
    id: string
    parentId?: string
    color?: string
    photoData?: PhotoData
    matIconName?: string
    disabled?: boolean
    hidden?: boolean
    searchTerm?: string
    hideTitle?: boolean
    showTitle?: boolean // this is for the actual title property, not the title of a grouping.  Wow what a mess this is

    isDate?: boolean
    children?: FilterUI[]
    asset?: Asset
		innerGroupId?: string // here because sometimes there are different types inside of a filter group
    soloSelection?: boolean // when this type of filter is selected it should remove all other filters and just go to this filter.  This is being created for the inactive accounts in the main home view

}

export interface FiltersGroupUI {
    title?: string,
    groupId: string,
		filters: FilterUI[],
		hideTitle?: boolean
}

export interface FiltersGroupingUI {
    filterGroups: FiltersGroupUI[]
    title?: string
    emptyMessage?: string
    rightColumn?: boolean
    defaultClosed?: boolean
}

export interface FilterDialogData {
    filterPage: string
    filterGroupings: FiltersGroupingUI[]
}


export interface FilterDialogComponentParams {
    width: string,
    autoFocus: boolean,
    data: FilterDialogData
}

